import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { GlChoiceGrid } from "./GlChoiceGrid";

// Prompt 23 A1 — shown on the Dashboard once the billing email is confirmed
// and the company hasn't chosen its accounting system yet.
export default function PrimaryGlDialog({ onSaved }) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("lf_primary_gl_later")) return;
    Promise.all([api.get("/companies/me"), api.get("/onboarding/checklist")])
      .then(([me, cl]) => {
        const co = me.data?.company;
        const billingDone = (cl.data?.steps || []).some((s) => s.key === "billing_email" && s.done);
        if (!me.data?.is_super_admin && co && !co.primary_gl && billingDone) setOpen(true);
      })
      .catch(() => {});
  }, []);

  const choose = async (erp) => {
    setSaving(true);
    setError(null);
    try {
      await api.put("/companies/me/primary-gl", { primary_gl: erp });
      setOpen(false);
      onSaved && onSaved(erp);
      navigate("/connections");
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not save your choice");
    } finally {
      setSaving(false);
    }
  };

  const later = () => {
    sessionStorage.setItem("lf_primary_gl_later", "1");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => (o ? setOpen(true) : later())}>
      <DialogContent className="max-w-xl" data-testid="primary-gl-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Which accounting system do you use?</DialogTitle>
          <DialogDescription>
            Bills from your vendors will go into this system. You can add another one later.
          </DialogDescription>
        </DialogHeader>
        <GlChoiceGrid onSelect={choose} disabled={saving} />
        {error ? <div className="text-sm text-red-700" data-testid="primary-gl-error">{error}</div> : null}
        <div className="flex justify-end">
          <button type="button" className="text-xs uppercase tracking-widest text-neutral-500 hover:text-neutral-900"
                  onClick={later} data-testid="primary-gl-later">
            decide later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
